import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios, publicAxios } from "../api";

export const fetchAllNotification = createAsyncThunk(
  "notification/fetchAllNotification",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(`/api/user/notifications`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid code.");
      }

      return response.data.data.notifications;
    } catch (error) {
      console.error("Error fetching notification:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch notification"
      );
    }
  }
);

export const markAsViewed = createAsyncThunk(
  "notification/markAsViewed",
  async (notification_id, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/notifications/view`,
        { notification_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid operation.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error marking notification as viewed:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to mark notification"
      );
    }
  }
);

const initialState = {
  allNotification: null,
  status: "idle",
  error: null,
};

const allNotificationSlice = createSlice({
  name: "allNotification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllNotification.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllNotification.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allNotification = action.payload;
      })
      .addCase(fetchAllNotification.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(markAsViewed.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(markAsViewed.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(markAsViewed.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default allNotificationSlice.reducer;
